module.exports = __webpack_public_path__ + "static/2_1_search-2_GA-046ea29ae40dad6f28f259305fd3e7ef.svg";